import { Map } from 'immutable';

import {
    UPDATE_PACKAGE_STATES,
    UPDATE_PACKAGE_TASK_STATES,
    UPDATE_TASK_ITEM_STATES,
    DEEP_UPDATE_PACKAGE_STATE,
    DEEP_UPDATE_PACKAGE_TASK_STATE,
    DEEP_UPDATE_TASK_ITEM_STATE,
} from './actions';

export const PACKAGE_STATES_KEY = 'packageStates';
export const TASK_STATES_KEY = 'taskStates';
export const TASK_ITEM_STATES_KEY = 'taskItemStates';

export function packageStatesReducer(state = Map(), action) {
    switch (action.type) {
        case UPDATE_PACKAGE_STATES:
            return state.merge(action.newPackageStates);
        case DEEP_UPDATE_PACKAGE_STATE:
            return state.update(action.entityId, states => states && states.merge(action.updates));
    }
    return state;
}

export function taskStatesReducer(state = Map(), action) {
    switch (action.type) {
        case UPDATE_PACKAGE_TASK_STATES:
            return state.merge(action.newTaskStates);
        case DEEP_UPDATE_PACKAGE_TASK_STATE:
            return state.update(action.entityId, states => states && states.merge(action.updates));
    }
    return state;
}

export function taskItemStatesReducer(state = Map(), action) {
    switch (action.type) {
        case UPDATE_TASK_ITEM_STATES:
            return state.merge(action.newTaskItemStates);
        case DEEP_UPDATE_TASK_ITEM_STATE:
            return state.update(action.entityId, states => states && states.merge(action.updates));
    }
    return state;
}
